var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconActionBarToken = function SvgIconActionBarToken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 2.8c0 .5-.4.9-.8.9s-.9-.4-.9-.9.4-.9.8-.9.9.4.9.9zM2.3.6C1.1.6.2 1.6.2 2.8.2 4 1.1 5 2.3 5c1.2 0 2.1-1 2.1-2.2 0-1.2-1-2.2-2.1-2.2z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 6.5l-2.3 1.7-1.1-.9c-.2-.2-.6-.2-.8 0l-1.1.9-1.1-.9c-.2-.2-.6-.2-.8 0l-1.3 1.1h-3.2c-.2 0-.5.1-.6.4-.8 1.8-2.5 2.9-4.3 2.9-2.6 0-4.7-2.2-4.7-4.9S4.4 1.9 7 1.9c1.9 0 3.6 1.1 4.3 2.9.1.2.3.4.6.4h10l1.7 1.3zM25 6l-2.5-2c-.1-.1-.3-.1-.4-.1h-9.9C11.1 1.9 9.1.6 6.9.6 3.6.6.9 3.4.9 6.8.9 10.2 3.7 13 7 13c2.2 0 4.2-1.3 5.3-3.3h3.1c.2 0 .3-.1.4-.2l1.1-.9 1.1.9c.2.2.6.2.8 0l1.1-.9 1.1.9c.2.2.5.2.8 0L25 7.1c.2-.1.3-.3.3-.5s-.1-.4-.3-.6z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4566",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M-4.8-4.4H9.4V10H-4.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 6.8c0 .5-.4.9-.8.9s-.9-.4-.9-.9.4-.9.8-.9.9.4.9.9h0zm-.8-2.2c-1.2 0-2.1 1-2.1 2.2C3.2 8 4.1 9 5.3 9c1.2 0 2.1-1 2.1-2.2 0-1.2-1-2.2-2.1-2.2h0z",
    stroke: "#1C4566",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4566",
    fillRule: "nonzero",
    mask: "url(#d)",
    d: "M-4.1-4.4h34.4V18H-4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 6.5l-2.3 1.7-1.1-.9c-.2-.2-.6-.2-.8 0l-1.1.9-1.1-.9c-.2-.2-.6-.2-.8 0l-1.3 1.1h-3.2c-.2 0-.5.1-.6.4-.8 1.8-2.5 2.9-4.3 2.9-2.6 0-4.7-2.2-4.7-4.9S4.4 1.9 7 1.9c1.9 0 3.6 1.1 4.3 2.9.1.2.3.4.6.4h10l1.7 1.3h0zM25 6l-2.5-2c-.1-.1-.3-.1-.4-.1h-9.9C11.1 1.9 9.1.6 6.9.6 3.6.6.9 3.4.9 6.8.9 10.2 3.7 13 7 13c2.2 0 4.2-1.3 5.3-3.3h3.1c.2 0 .3-.1.4-.2l1.1-.9 1.1.9c.2.2.6.2.8 0l1.1-.9 1.1.9c.2.2.5.2.8 0L25 7.1c.2-.1.3-.3.3-.5s-.1-.4-.3-.6z",
    stroke: "#1C4566",
    strokeWidth: 0.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconActionBarToken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-action-bar-token.d7973c77.svg";
export { ForwardRef as ReactComponent };